import { Injectable } from '@angular/core';
import { Path } from '@s8l/client-tree-lib';

import { CmsServerService } from './jsonrpc/cms-server.service';

export enum CacheState {
  Idle = 0,
  Loading,
  Done,
  Error
}

@Injectable({
  providedIn: 'root'
})
export class ImageCacheService {
  private _urls: { [s: string]: Promise<string> } = {};
  private _times: { [s: string]: number } = {};
  private _state: { [s: string]: CacheState } = {};

  constructor(private server: CmsServerService) {}

  public loading(path: Path): boolean {
    return this._state[path.uri()] == CacheState.Loading;
  }

  public done(path: Path): boolean {
    return this._state[path.uri()] == CacheState.Done;
  }

  public parseUrl(path: string): Promise<string> {
    return this.url(Path.parse(path));
  }

  public invalidate(path: Path) {
    const uri = path.uri();
    this._urls[uri] = null;
  }

  public url(path: Path): Promise<string> {
    const uri = path.uri();

    // Check if the link expired
    if (this._times[uri] && Math.abs(Date.now() - this._times[uri]) / 36e5 >= 4) {
      this._urls[uri] = null;
    }

    if (!this._urls[uri]) {
      this._state[uri] = CacheState.Loading;

      let request = null;

      if (path.get().length === 1 && /(\w+-?)+/.test(path.getFirst())) {
        // Legacy support, new media servers should accept both uuid and path in the download request
        request = this.server.mediaDownload({
          uuid: path.getFirst()
        });
      } else {
        request = this.server.mediaDownload({
          path: uri
        });
      }

      this._urls[uri] = request
        .then(res => {
          this._state[uri] = CacheState.Done;
          this._times[uri] = Date.now();
          return res.url;
        })
        .catch(err => {
          console.warn(err);
          this._state[uri] = CacheState.Error;
          return 'https://via.placeholder.com/150';
        });
    }
    return this._urls[uri];
  }
}
